<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_4"></a>This is a work of fiction. All the characters and events portrayed in this novel are either fictitious or are used fictitiously.</p>
<p class="copyright">THE BOOK OF KNIGHTS</p>
<p class="copyright">Copyright © 1998 by Yves Meynard</p>
<p class="copyright">All rights reserved, including the right to reproduce this book, or portions thereof, in any form.</p>
<p class="copyright">This book is printed on acid-free paper.</p>
<p class="copyright">Edited by David G. Hartwell</p>
<p class="copyright">A Tor Book</p>
<p class="copyright">Published by Tom Doherty Associates, Inc.</p>
<p class="copyright">175 Fifth Avenue</p>
<p class="copyright">New York, NY 10010</p>
<p class="copyright">Tor Books on the World Wide Web:<br/><span class="weblink"><a class="nounder" href="http://www.tor.com" target="_blank">http://www.tor.com</a></span></p>
<p class="copyright">Tor<sup>®</sup> is a registered trademark of Tom Doherty Associates, Inc.</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Meynard, Yves<br/>        The book of Knights / Yves Meynard.<br/>        p. cm.<br/>        “A Tom Doherty Associates book.”<br/>        ISBN: 978-0-312-86831-4<br/>        ISBN: 0-312-86831-6<br/>        I Tide.<br/>    PR9199.3.M4524B6  1998<br/>    813’.54—dc21<br/>                                                                                     97-34387<br/>                                                                                           CIP</p>
<p class="copyright">First Edition: February 1998<br/>First Trade Paperback Edition: April 1999</p>
<p class="copyright">Printed in the United States of America</p>
<p class="copyright">0  9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?212a710f